import { useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import WebTableBody from "./WebTableBody";
import WebForm from "./WebForm/WebForm";

import classes from "../maintainers.module.scss";

import { useWebPages, useMutationWebPage } from "@/hooks/maintainers/web";

const Web = () => {
	const { addToast } = useToasts();
	const { option } = useParams();

	const { data, isLoading, isFetching } = useWebPages();
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutationWebPage();

	const { list: webPages, contents } = data ? data : {};

	const confirmSave = (data) => {
		mutateSave(
			{ params: { ...data } },
			{
				onSuccess: () => {
					addToast("Página guardada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	if (isLoading) {
		return <Fetching />;
	}

	return (
		<>
			<Head title="Páginas Web" button={false} back_url={"/mantenedores"} isFetching={isFetching} />

			<div className={classes.table_div}>
				<WebTableBody webPages={webPages} />
			</div>

			{option && <WebForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} allContents={contents} />}
		</>
	);
};

export default Web;
